import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = {
  class: "open-ai-lives"
};
const _hoisted_2 = {
  class: "body"
};
const _hoisted_3 = {
  class: "room-info"
};
const _hoisted_4 = {
  class: "room-number"
};
const _hoisted_5 = {
  class: "input"
};
import { ref, onMounted } from "vue";
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import router from '@/router/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'openAiLives',
  setup(__props) {
    let roomNumber = ref('');
    const checkRoomNumber = () => {
      if (!roomNumber.value) {
        ElMessage.warning('房间号ID不能为空');
      }
    };
    const enterRoom = () => {
      if (!roomNumber.value) {
        ElMessage.warning('请输入房间号ID');
        return;
      }
      const numberPattern = /^\d+$/;
      if (!numberPattern.test(roomNumber.value)) {
        ElMessage.warning('房间号ID必须是数字');
        return;
      }
      ElMessage.success('正在进入房间...');
      // 进入房间的逻辑
      router.push(`/ai-Lives?roomId=${roomNumber.value}`);
      console.log('进入房间:', roomNumber.value);
    };
    onMounted(async () => {
      // 隐藏指定的标签
      setTimeout(() => {
        const chatbotBubbleButton = document.getElementById('dify-chatbot-bubble-button');
        const viewFooter = document.querySelector('.view-footer');
        if (viewFooter) {
          viewFooter.style.display = 'none';
        }
        if (chatbotBubbleButton) {
          chatbotBubbleButton.style.display = 'none';
        }
      }, 300); // 延迟1秒
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "header"
      }, [_createElementVNode("div", {
        class: "logo"
      }, [_createElementVNode("img", {
        src: _imports_0
      }), _createElementVNode("span", null, "万川数字人互动系统")])], -1)), _createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "description"
      }, [_createElementVNode("p", null, "欢迎来到万川数字人互动系统。这里融合了数字人技术与直播，致力于为用户提供独特的互动体验。不论是观看表演还是探索新的交流方式，我们都期待您的加入。")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "label"
      }, "房间号ID:", -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: _unref(roomNumber),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(roomNumber) ? roomNumber.value = $event : roomNumber = $event),
        placeholder: "请输入房间号ID",
        onBlur: checkRoomNumber
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", {
        class: "enter-button",
        onClick: enterRoom
      }, "进入")])])]);
    };
  }
});